import script from "./ViewFireExtinguisher.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewFireExtinguisher.vue?vue&type=script&setup=true&lang=js"

import "./ViewFireExtinguisher.vue?vue&type=style&index=0&id=10ebc950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ebc950"]])

export default __exports__